/**
 * Given a hostname and a dot-prefixed root domain that the hostname is expected to fall
 * within, returns every domain level between the hostname and the root domain (inclusive),
 * ordered from most to least specific. For example, given the hostname "a.b.c.com" and the
 * root domain ".c.com", returns ["a.b.c.com", "b.c.com", "c.com"].
 *
 * If the hostname doesn't actually fall within the root domain, returns the root domain
 * alone, since there's no meaningful hierarchy to walk.
 */
export const getDomainHierarchy = (
  hostname: string,
  rootDomain: string,
): string[] => {
  const root = rootDomain.replace(/^\./, '');

  if (hostname !== root && !hostname.endsWith(`.${root}`)) {
    return [root];
  }

  const hostLabels = hostname.split('.');
  const rootLabelCount = root.split('.').length;
  const levels: string[] = [];

  for (let i = 0; i <= hostLabels.length - rootLabelCount; i += 1) {
    levels.push(hostLabels.slice(i).join('.'));
  }

  return levels;
};
